export default [
    {
        path: "/property-transfer",
        component: () => import("../Components/List.vue"),
        name: "property.transfer",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property-transfer/create",
        component: () => import("../Components/Create.vue"),
        name: "property.transfer.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/property-transfer/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "property.transfer.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/property-transfer/:id/view",
        component: () => import("../Components/Show.vue"),
        name: "property.transfer.show",
        meta: {
            requiresAuth: true,
        },
    },
];
